<template>
    <div class="flux-fondos-step">
      <div class="flux-fondos-step__msg">{{ $t("guest.funds.dataPurpose", {name: list.ownerName}) }}</div>
      <div class="flux-fondos-form">
        <div class="bb-form-item">
          <label class="bb-form-label" for="name">{{ $t("generic.name") }}</label>
          <input
            id="name"
            type="text"
            class="bb-form"
            v-model="name"
            required
            :placeholder="$t('guest.funds.yourName')"
          />
        </div>
        <div class="bb-form-item">
          <label class="bb-form-label" for="email">Email</label>
          <input
            id="email"
            type="email"
            class="bb-form"
            v-model="email"
            required
            :placeholder="$t('guest.funds.yourEmail')"
          />
        </div>
        <div class="bb-form-item">
          <label class="bb-form-label" for="amount">{{ $t("guest.funds.howMuch") }}</label>
          <input id="amount" type="number" class="bb-form" placeholder="0" v-model="amount" required/>
        </div>
      </div>
      <div class="flux-fondos-step__actions">
        <button class="button button--primary button--block" @click="next" :disabled="disabled">{{ $t("generic.next") }}</button>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "FluxFondosClassicStep2",
    props: {
      fund: {
        type: Object,
        required: true
      },
      list: {
        type: Object,
        required: true
      },
      paymentMethod: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        name: '',
        email: '',
        amount: '',
      }
    },
    computed: {
      disabled() {
        return !(this.name !== '' && this.amount !== '' && this.$utils.validateEmail(this.email))
      }
    },
    methods: {
      next() {
        this.$emit('next',{
          name: this.name,
          email: this.email,
          amount: parseFloat(this.amount),
          paymentMethod: this.paymentMethod,
          paymentName: this.list.contributionMethods.find(x => x.methodId === this.paymentMethod).method.name,
          paymentData: this.list.contributionMethods.find(x => x.methodId === this.paymentMethod).data,
          paymentSlug: this.list.contributionMethods.find(x => x.methodId === this.paymentMethod).method.slug,
        })
      }
    }
  };
  </script>
